import {Link, useParams, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import styles from "../styles/HomePage.module.css";
import {getColorForGameScore, renderSkaterTable} from "./GamePage";
import {RenderGameList} from "./TeamGamesPage";


function RenderStandoutPerformances(skaters) {
  return (
    <div className={styles.tableContainer}>
      <h1 className={styles.tableTitle}>Top Game Ratings</h1>
      <div className={styles.cardRowsContainer}>
        {Object.entries(skaters)
          .sort(([, a], [, b]) => b.game_rating - a.game_rating)
          .slice(0, 10)
          .map(([playerId, playerDict], index) => (
            <div key={playerId} className={styles.cardRow}>
              {/* Rank */}
              <div className={styles.cardCell + ' ' + styles.indexCell}>{index + 1}</div>
              {/* Player */}
              <div className={styles.cardCell + ' ' + styles.playerCell}>
                <Link to={`/players/id/${playerId}`} className={styles.playerLink}>
                  <img
                    className={styles.mug}
                    src={`https://assets.nhle.com/mugs/nhl/${playerDict.season}/${playerDict.team_abb}/${playerId}.png`}
                    alt={playerDict.name}
                  />
                  <span className={styles.playerName} style={{'--primary-color': playerDict.primary_color}}>{playerDict.name}</span>
                </Link>
              </div>
              {/* Game */}
              <div className={styles.cardCell + ' ' + styles.gameCell}>
                <Link to={`/games/id/${playerDict.game_id}`} className={styles.playerLink}>
                  <span className={styles.playerName}>
                    <img
                      className={styles.teamLogoMini}
                      src={`https://assets.nhle.com/logos/nhl/svg/${playerDict.team_abb}_light.svg`}
                      alt={playerDict.team_abb}
                    />
                    {playerDict.for_score} — {playerDict.ag_score}
                    <img
                      className={styles.teamLogoMini}
                      src={`https://assets.nhle.com/logos/nhl/svg/${playerDict.against_abb}_light.svg`}
                      alt={playerDict.against_abb}
                    />
                  </span>
                </Link>
              </div>
              {/* Rating */}
              <div className={styles.cardCell + ' ' + styles.ratingCell}>
                <Link to={`/games/id/${playerDict.game_id}`} className={styles.ratingLink}>
                  {playerDict.game_rating.toFixed(2)}
                </Link>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

function formatDate(dateString) {
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return date.toLocaleDateString(undefined, options);
}

function RenderRecentGamesCardList({ games }) {
  const navigate = useNavigate();
  if (!games || !games.length) return null;
  return (
    <div className={styles.cardRowsContainer}>
      {games.map((game, idx) => (
        <div
          key={game.id}
          className={styles.cardRow}
          style={{ cursor: "pointer" }}
          onClick={e => {
            // Only navigate if the click target is not a link or inside a link
            if (!e.target.closest("a")) {
              navigate(`/games/id/${game.id}`);
            }
          }}
        >
          {/* Date */}
          <div className={styles.cardCell + ' ' + styles.indexCell} style={{fontWeight: 600, fontSize: 'clamp(14px, 1.2vw, 20px)', flex: '0 0 170px', maxWidth: 170}}>
            <span className={styles.gameDate}>{formatDate(game.date)}</span>
          </div>
          {/* Game Group: Winner Logo, Score, Loser Logo */}
          <div className={styles.gameGroup} style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <Link to={`/teams/${game.winner}/`} className={styles.playerLink} style={{display: 'flex', alignItems: 'center', marginRight: 18}}>
              <img
                className={styles.teamLogoMini}
                src={`https://assets.nhle.com/logos/nhl/svg/${game.winner}_light.svg`}
                alt={`${game.winner} logo`}
              />
            </Link>
            <Link to={`/games/id/${game.id}`} className={styles.playerLink} style={{display: 'flex', alignItems: 'center'}}>
              <span className={styles.playerName} style={{textAlign: 'center', minWidth: 90, fontWeight: 600}}>
                {game.winner_score} — {game.loser_score}
                {game.final_period === "OT" && <span> (OT)</span>}
                {game.final_period === "SO" && <span> (SO)</span>}
              </span>
            </Link>
            <Link to={`/teams/${game.loser}/`} className={styles.playerLink} style={{display: 'flex', alignItems: 'center', marginLeft: 18}}>
              <img
                className={styles.teamLogoMini}
                src={`https://assets.nhle.com/logos/nhl/svg/${game.loser}_light.svg`}
                alt={`${game.loser} logo`}
              />
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
}

function HomePage() {
    const [recentData, setRecentData] = useState({});
    // const [recentGames, setRecentGames] = useState({});
    // const [surprisePerformances, setSurprisePerformances] = useState([])
    // const [powerRankings, setPowerRankings] = useState([])
    // const [gameRatingLeaders, setGameRatingLeaders] = useState([])
    // const [goalLeaders, setGoalLeaders] = useState([])
    // const [expectedGoalLeaders, setExpectedGoalLeaders] = useState([])
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        getData()
            .catch(err => {
                console.log(err);
            });
    }, [])

    const getData = async () => {
        setLoading(true);

        const today = new Date();
        const yyyy = today.getFullYear();
        let mm = today.getMonth() + 1; // Months are zero-based
        let dd = today.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        const todaysDate = `${yyyy}-${mm}-${dd}`;

      let apiUrl = `/api/recent/${todaysDate}`;
      try {
        const recentResp = await fetch(apiUrl);
        const recentData = await recentResp.json();
        setRecentData(recentData);
      } catch (err) {
          console.error('Error fetching data:', err);
      } finally {
        setLoading(false);
      }
    };

     if (loading) {
        return (
            <div className="d-flex justify-content-center">
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.pageContainer}>
            <h1 className={styles.tableTitle}>Recent Games</h1>
            {/*<p className={styles.tableSubtitle}>*/}
            {/*    Games from most recent gameday*/}
            {/*</p>*/}
            <div className={styles.recentGamesSection}>
                <div className="text-center col-me-6 col-sma-10 mc-auto p-0">
                    <div className={`card p-3 text-center ${styles.recentGamesCard}`} style={{background: 'none', boxShadow: 'none', border: 'none', padding: 0}}>
                        <RenderRecentGamesCardList games={recentData.recent_games} />
                    </div>
                </div>
            </div>
            {recentData.key_performances && RenderStandoutPerformances(recentData.key_performances)}
        </div>
    );
}

export default HomePage